/** The shapes the API sends back, beyond what @dp/shared already declares. */
import type { DataType, EntityDefinition, FieldDefinition, FieldValidation, ValueDomain } from "@dp/shared";

export interface EntityRow extends EntityDefinition {
  fieldCount: number;
}

export interface DomainRow extends ValueDomain {
  fieldCount: number;
}

export interface FieldRow extends FieldDefinition {
  entityLabel: string;
  entityRepeating: boolean;
  domainLabel: string | null;
  useCount: number;
}

export interface FieldReference {
  productId: string;
  productCode: string;
  productName: string;
  version: number;
  status: string;
}

export const DATA_TYPE_LABELS: Record<DataType, string> = {
  text: "Text",
  long_text: "Long text",
  integer: "Whole number",
  decimal: "Decimal",
  money: "Money",
  percent: "Percentage",
  boolean: "Yes / no",
  date: "Date",
  choice: "Choice",
  multi_choice: "Choice, many",
  email: "Email address",
  phone: "Phone number",
};

export type { DataType, FieldValidation };
